import type { Message, Thread } from '../claims/interface';
import { deserialize, fetchWrapper } from '../fetch';

export const create = async (data: {
  dossierId: string;
  threadName: string;
}): Promise<{ thread_id: string }> => {
  const { dossierId, threadName } = data;
  const url = new URL(`/app/v1/${dossierId}/threads`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        dossier_id: dossierId,
        thread_name: threadName,
      }),
    })
  );
};

export const getThreads = async ({
  dossierId,
  limit,
  offset,
}: {
  dossierId: string;
  limit?: number;
  offset?: number;
}): Promise<{ threads: Thread[]; count: number | null }> => {
  const url = new URL(`/app/v1/${dossierId}/threads`, API_BASE_URL);
  if (typeof limit === 'number') {
    url.searchParams.set('limit', String(limit));
  }
  if (typeof offset === 'number') {
    url.searchParams.set('offset', String(offset));
  }
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const getMessages = async ({
  dossierId,
  threadId,
}: {
  dossierId: string;
  threadId: string;
}): Promise<{ messages: Message[] }> => {
  const url = new URL(
    `/app/v1/${dossierId}/threads/${threadId}/messages`,
    API_BASE_URL
  );
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};

export const deleteThread = async ({
  dossierId,
  threadId,
}: {
  dossierId: string;
  threadId: string;
}): Promise<void> => {
  const url = new URL(`/app/v1/${dossierId}/threads/${threadId}`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, { method: 'DELETE', credentials: 'include' })
  );
};
